import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DigitalTools from "../assets/images/academy-insights/academy-blog1.jpg";

const AdminLogin = () => {

  window.scrollTo(0, 0);
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    const API_URL = "https://sattva-backend.demetrix.in/auth/login";

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess("Login successful!");

        // Save token in localStorage
        if (data?.data?.[0]?.access_token) {
          localStorage.setItem("Editor_token", data.data[0].access_token);
        } else {
          console.warn("Access token not found in response!");
        }

        // Redirect to home
        navigate("/learning-and-insights", { replace: true });
      } else {
        setError(data.message || "Login failed!");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Optional semi-transparent overlay for better readability */}
      <div style={styles.overlay} />

      <div style={styles.formContainer}>
        <h2 style={styles.title}>Admin Login</h2>
        <form onSubmit={handleLogin} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          {success && <div style={styles.success}>{success}</div>}

          <label style={styles.label}>Email</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
          />

          <label style={styles.label}>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={styles.input}
          />
          {
            loading ? <div className="place-content-center flex items-center justify-center">
              <span className="w-8 h-8 animate-spin border-2 border-black dark:border-white !border-l-transparent align-middle  rounded-full inline-flex"></span>
            </div> : <button type="submit" style={styles.button} disabled={loading}>
              Login
            </button>
          }
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${DigitalTools})`, // ← use imported image here
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative", // needed for overlay
  },
  // Semi-transparent dark overlay (helps text/form stay readable)
  overlay: {
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.45)",         // adjust opacity 0.35–0.6 as needed
    zIndex: 1,
  },

  formContainer: {
    background: "rgba(255, 255, 255, 0.95)",        // slightly transparent white
    backdropFilter: "blur(10px)",                   // glassmorphism effect (modern look)
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
    width: "380px",
    maxWidth: "90%",
    position: "relative",
    zIndex: 2,                                      // above overlay
  },

  title: {
    textAlign: "center",
    marginBottom: "32px",
    color: "#1a1a1a",
    fontSize: "28px",
    fontWeight: "600",
  },

  form: {
    display: "flex",
    flexDirection: "column",
  },

  label: {
    marginBottom: "8px",
    fontWeight: "500",
    color: "#333",
  },

  input: {
    padding: "12px 16px",
    marginBottom: "20px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "16px",
    outline: "none",
    transition: "border-color 0.2s",
  },

  button: {
    padding: "12px",
    border: "none",
    background: "#3BAA5D",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "500",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background 0.2s",
  },

  error: {
    marginBottom: "16px",
    color: "#dc2626",
    fontWeight: "500",
    textAlign: "center",
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    padding: "10px",
    borderRadius: "6px",
  },

  success: {
    marginBottom: "16px",
    color: "#16a34a",
    fontWeight: "500",
    textAlign: "center",
    backgroundColor: "rgba(22, 163, 74, 0.1)",
    padding: "10px",
    borderRadius: "6px",
  },
};

export default AdminLogin;